<template>
  <div class="pagina">

    <v-alert v-if="alert.message" :type="alert.type" class="ma-4">
      {{ alert.message }}
    </v-alert>

    <div class="contenido-producto">
    <!-- COLUMNA IZQUIERDA: el producto -->
    <div class="columna">
    <!-- CAROUSEL -->
    <v-carousel
      :key="product.images.length"
      progress="primary"
      show-arrows="hover"
      hide-delimiter-background
      class="carousel"
    >
      <v-carousel-item
        v-for="image in product.images"
        :key="image.idImagen"
        :src="image.pathBase64"
        cover
      />
    </v-carousel>

    <!-- INFO PRODUCTO -->
    <div class="seccion-info">
      <div class="nombre-producto">{{ product.product }}</div>
      <div class="chips">
        <v-chip v-if="product.category" size="small" class="chip-categoria">
          <v-icon start size="14">mdi-tag</v-icon>
          {{ product.category }}
        </v-chip>
      </div>
      <div class="precio">{{ product.costs ? product.costs.toLocaleString() : '' }} COP</div>
      <p class="descripcion">{{ product.description }}</p>
    </div>

    </div>

    <!-- COLUMNA DERECHA: la empresa y su catalogo -->
    <div class="columna">
    <!-- EMPRESA -->
    <div v-if="product.company && product.company.idCompany" class="seccion-empresa">
      <div class="titulo-seccion">Empresa</div>
      <div class="empresa-info">
        <div class="empresa-nombre">{{ product.company.company }}</div>
        <div class="empresa-ubicacion" v-if="product.company.city">
          <v-icon size="14">mdi-map-marker</v-icon>
          {{ product.company.city }}
        </div>
      </div>
      <v-btn
        class="bg-blue text-white btn-empresa"
        @click="$router.push({ name: 'ViewCompanyView', params: { id: product.company.idCompany } })"
      >
        <v-icon class="mr-1">mdi-store</v-icon>
        Ver empresa
      </v-btn>
    </div>

    <!-- MÁS PRODUCTOS -->
    <div v-if="listProductsCompany.length > 0" class="seccion-productos">
      <div class="titulo-seccion">Más productos de {{ product.company.company }}</div>
      <div class="grilla-productos">
        <ComponentProduct
          v-for="iProduct in listProductsCompany"
          :key="iProduct.idProduct"
          :product="iProduct"
          @click="$router.push({ name: 'ViewProductView', params: { id: iProduct.idProduct } })"
        />
      </div>
    </div>
    </div>
    </div>

  </div>
</template>
<script>
import apisProducts from '@/apis/apisProducts';
import ComponentProduct from '@/components/ComponentProduct.vue';
import { ponerTitulo } from '@/router';

export default {
  name: 'ViewProductView',
  components: {
    ComponentProduct
  },
  data: function() {
    return {
      listProductsCompany: [],
      product: {
        idProduct: null,
        idCompany: null,
        product: "",
        category: "",
        description: "",
        costs: 10000,
        views: 0,
        images: [],
        company: {
            idCompany: null,
            idUser: null,
            company: "",
            country: "",
            city: "",
            description: "",
            location: "",
            phone: "",
            views: null,
            user: {
                idUser: null,
                user: "",
                password: "",
                name: "",
                surNames: "",
                email: "",
                age: null,
                role: "",
                phoneNumber: ""
            }
      }
      },
      alert: {
        type: '',
        message: ''
      }
    }
  },
  created() {
    this.idProduct = this.$route.params.id;

    apisProducts.getProductById(this.idProduct)
      .then(res => {
        this.product = res;
        this.product.images = [];
        ponerTitulo(res.product);

        // Load images
        apisProducts.ImagesProducts(this.idProduct)
          .then(images => {
            this.product.images = images;
          })

        // Cargamos productos de la misma empresa
        apisProducts.getProductsCompany(this.product.company.idCompany)
          .then(products => {
            this.listProductsCompany = products;

            // Remove the current product from the list
            this.listProductsCompany = this.listProductsCompany.filter(p => p.idProduct != this.idProduct)
          })
          .catch(error => {
            console.error('Error fetching company products:', error);
          });

        apisProducts.isProductEnabled(this.product.idProduct)
          .then(isEnamble => {
            if (!isEnamble){
              this.alert = {
                type: 'warning',
                message: '🚫 The product is not publicly visible.'
              };
            }
          })

      })
      .catch(() => {
        apisProducts.isProductEnabled(this.idProduct)
          .then(isEnamble => {
            if (isEnamble){
              this.alert = {
                type: 'warning',
                message: '🚫 Error loading.'
              };
            }else{
              this.alert = {
                type: 'warning',
                message: '🚫 The product is not publicly visible or does not exist.'
              };
            }
          })
      });

    

  }
};
</script>
<style scoped>
.pagina {
  max-width: 960px;
  margin: 0 auto;
  background: linear-gradient(160deg, #dbeafe 0%, #eff6ff 45%, #f8fafc 100%);
  min-height: 100vh;
  padding: 12px;
}

.carousel {
  width: 100%;
  height: 260px;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 12px;
}

/* INFO */
.seccion-info {
  background: #fff;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 14px;
}
.nombre-producto {
  font-size: 1.4rem;
  font-weight: 700;
  color: #111;
  margin-bottom: 8px;
}
.chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.chip-categoria {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.precio {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 10px;
}
.descripcion {
  color: #444;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* EMPRESA */
.seccion-empresa {
  background: #fff;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 14px;
}
.titulo-seccion {
  font-size: 1rem;
  font-weight: 600;
  color: #111;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #1976d2;
}
.empresa-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.empresa-nombre {
  font-weight: 600;
  font-size: 1rem;
}
.empresa-ubicacion {
  font-size: 0.85rem;
  color: #777;
  display: flex;
  align-items: center;
  gap: 2px;
}
.btn-empresa {
  width: 100%;
}

/* MÁS PRODUCTOS */
.seccion-productos {
  background: #fff;
  padding: 16px;
  border-radius: 14px;
}
.grilla-productos {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

/* De base una sola columna: en celular el orden es el mismo de siempre
   (carrusel, info, empresa, productos) */
.contenido-producto {
  display: grid;
  grid-template-columns: 1fr;
}

@media (min-width: 500px) {
  .grilla-productos {
    grid-template-columns: repeat(3, 1fr);
  }
  .carousel {
    height: 320px;
  }
}

/* En computador se parte en dos paneles para no tener que bajar hasta el
   final a ver que mas vende la empresa. Va despues del bloque de 500px
   para poder revertir la grilla a 2 columnas dentro del panel derecho. */
@media (min-width: 900px) {
  .pagina {
    max-width: 1240px;
  }
  .contenido-producto {
    grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
    gap: 14px;
    align-items: start;
  }
  .grilla-productos {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>